import useFormTextState from './useFormTextState';
import React, { ChangeEvent } from 'react';

const useTableSearch = (
  searchValue?: boolean | undefined,
): {
  searchValue: string | undefined;
  onSearchChange: (e: ChangeEvent<HTMLInputElement>) => void;
  setSearchValue: React.Dispatch<React.SetStateAction<string | undefined>>;
} => {
  const searchProps = useFormTextState(undefined, undefined, 300);

  return {
    searchValue: searchValue ? undefined : searchProps.value,
    onSearchChange: searchProps.onChangeText,
    setSearchValue: searchProps.setValue,
  };
};

export default useTableSearch;
